import { render, staticRenderFns } from "./photoViewer_component.vue?vue&type=template&id=3baaf888&"
import script from "./photoViewer_component.vue?vue&type=script&lang=js&"
export * from "./photoViewer_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports